// Mobile hamburger + accordion drawer for the legacy analyzer top nav
// (template/elements/nav/top/full.html). Active only at <= 64em; on desktop
// the Foundation hover dropdowns are left untouched. Self-contained: no
// jQuery / Foundation dependency.

const bar = document.getElementById('top_bar');
const toggle = document.getElementById('nav-hamburger');
const menu = document.getElementById('main_menu');

if (bar && toggle) {
    const mq = window.matchMedia('(max-width: 64em)');

    if (menu) {
        // Flag expandable top-level items (those with a submenu) so the CSS
        // caret and the accordion click handler only target real sections,
        // not leaf links like "Support".
        Array.from(menu.children).forEach(li => {
            if (li.querySelector('ul.menu, .is-dropdown-submenu')) {
                li.classList.add('nav-has-sub');
            }
        });

        menu.addEventListener('click', ev => {
            if (!mq.matches) {
                return;
            }
            // Walk up from the click target to the nearest anchor.
            let node = ev.target;
            while (node && node !== menu && node.tagName !== 'A') {
                node = node.parentElement;
            }
            if (!node || node.tagName !== 'A') {
                return;
            }
            const li = node.parentElement;
            // Only intercept top-level expandable sections; leaf links and
            // any nested submenu item navigate / run their handler normally.
            if (!li || li.parentElement !== menu || !li.classList.contains('nav-has-sub')) {
                return;
            }
            ev.preventDefault();
            ev.stopPropagation();
            li.classList.toggle('nav-expanded');
        });
    }

    toggle.addEventListener('click', ev => {
        ev.preventDefault();
        const open = bar.classList.toggle('nav-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    const onMqChange = ev => {
        if (ev.matches) {
            return;
        }
        // Back to desktop: reset drawer + accordion state.
        bar.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (menu) {
            Array.from(menu.querySelectorAll('.nav-expanded')).forEach(li => li.classList.remove('nav-expanded'));
        }
    };
    if (mq.addEventListener) {
        mq.addEventListener('change', onMqChange);
    } else if (mq.addListener) {
        mq.addListener(onMqChange);
    }
}
